import { RouteObject } from 'react-router'
import checkInQuestionRoute from './activities/checkIns/routes'
import awardsSetupRoutes from './admin/engagement/awards/routes'
import adminRoutes from './admin/routes'
import awardsRoutes from './awards/routes'
import cardRoutes from './cards/routes'
import celebrateRoutes from './celebrate/routes'
import cultureRoutes from './culture/routes'
import homeRoute from './home/routes'
import incentivesRoutes from './incentives/routes'
import memberRoutes from './me/routes'
import mobileRoutes from './mobile/routes'
import recognitionRoutes from './recognition/routes'
import resourceHubRoutes from './resourceHub/routes'
import rewardsRoutes from './rewards/routes'
import settingsRoutes from './settings/routes'
import teamsLinkRoutes from './teamsLink/routes'
import userDirectoryRoute from './userDirectory/routes'
import yourDirectReportsRoute from './yourDirectReports/routes'

const routes: RouteObject[] = [
  ...adminRoutes,
  ...memberRoutes,
  ...settingsRoutes,
  ...homeRoute,
  ...recognitionRoutes,
  ...resourceHubRoutes,
  ...checkInQuestionRoute,
  ...rewardsRoutes,
  ...yourDirectReportsRoute,
  ...awardsSetupRoutes,
  ...awardsRoutes,
  ...celebrateRoutes,
  ...cardRoutes,
  ...incentivesRoutes,
  ...cultureRoutes,
  ...teamsLinkRoutes,
  ...userDirectoryRoute,
  ...mobileRoutes,
]

export default routes
